import {http, HttpResponse} from "msw";
import {waitTime} from "@shared/mocks/wait-time";
import {StationDto} from "@shared/dto";
import {ConnectionStatus, RequiredActionEnum} from "@shared/enum";
import {UserConsole} from "@pages/console/model/user-console.model";
import {MessageStatus} from "@shared/model/message-status";

const stations: Record<string, StationDto> = {
    "c4fffc77-0242-4824-9e9c-45a114541670": {
        "id": "c4fffc77-0242-4824-9e9c-45a114541670",
        "pcid": "12345abc",
        "name": "Демонстрационный объект №1",
        "connection_status": ConnectionStatus.CONNECTED,
        "is_authorized": false,
        "required_action": RequiredActionEnum.AUTHORIZATION,
        "blower_module": null,
        "air_masters_pro": [
            {
                "id": "736f3fb9-93d3-4e39-b0fd-786520351549",
                "name": "Линия биологической очистки",
                "recirculation_group": {
                    "id": "efa2e1db-026a-4de8-98a0-0ac684be6bb8",
                    "name": "Группа насосов рециркуляции",
                    "return_recycling_pump_group": {
                        "id": "33ec224d-02ac-4e57-87b2-753e929af93a",
                        "name": "Группа насосов возвратного рецикла",
                        "pumps": [
                            {
                                "id": "7f0d10e6-4604-4573-bd14-c843ff6da8c3",
                                "name": "Насос",
                                "details": [
                                    {
                                        "id": "9fc3837a-de66-4555-b1a5-a679fb042ba4",
                                        "name": "SET_MODE",
                                        "unit": "NONE",
                                        "local_name": "Режим работы",
                                        "value": 0
                                    },
                                    {
                                        "id": "c892e258-7d27-46db-aaa1-c74e6efd7e6a",
                                        "name": "SET_CURRENT_MIN",
                                        "unit": "",
                                        "local_name": "Уставка минимального тока",
                                        "value": 0
                                    },
                                    {
                                        "id": "7d5d309e-cb76-4020-a162-1302131219c6",
                                        "name": "SET_CURRENT_MAX",
                                        "unit": "",
                                        "local_name": "Уставка максимального тока",
                                        "value": 0
                                    }
                                ],
                                "sequence_number": 1,
                                "metric_set": {
                                    raw: [
                                        {
                                            "id": "234404ef-be40-4d78-bb4b-debea0065e3d",
                                            "local_name": "Состояние",
                                            "name": "STATE",
                                            "unit": "NONE"
                                        }
                                    ],
                                    "analytical": []
                                }
                            }
                        ],
                        "details": []
                    },
                    "stabilization_pump_group": {
                        "id": "a1ae3924-709f-4d15-9654-5e3bcf928ec8",
                        "name": "Группа насосов камеры стабилизации",
                        "pumps": [
                            {
                                "id": "f6bcc0af-0b7b-49eb-aa47-24c25d6d57c5",
                                "name": "Насос",
                                "details": [
                                    {
                                        "id": "701907d2-f9e9-48ad-ac9a-e0c765c5d1b0",
                                        "name": "SET_CURRENT_MIN",
                                        "unit": "",
                                        "local_name": "Уставка минимального тока",
                                        "value": 0
                                    },
                                    {
                                        "id": "bdba96b8-ed49-4e37-8b73-4a138b6cdc32",
                                        "name": "SET_MODE",
                                        "unit": "NONE",
                                        "local_name": "Режим работы",
                                        "value": 0
                                    },
                                    {
                                        "id": "49041fbb-f18d-4e31-945d-ec31e422bc37",
                                        "name": "SET_CURRENT_MAX",
                                        "unit": "",
                                        "local_name": "Уставка максимального тока",
                                        "value": 0
                                    }
                                ],
                                "sequence_number": 1,
                                "metric_set": {
                                    raw: [
                                        {
                                            "id": "50a789d0-4421-49aa-915e-291620b60e86",
                                            "local_name": "Состояние",
                                            "name": "STATE",
                                            "unit": "NONE"
                                        }
                                    ],
                                    "analytical": []
                                }
                            },
                            {
                                "id": "54e276e5-6f57-4c3e-9ece-aa878baa3141",
                                "name": "Насос",
                                "details": [
                                    {
                                        "id": "0c541ab8-524f-45c7-8671-d38c10ffb02d",
                                        "name": "SET_CURRENT_MAX",
                                        "unit": "",
                                        "local_name": "Уставка максимального тока",
                                        "value": 0
                                    },
                                    {
                                        "id": "39c1487b-a4bd-404f-8a6c-25fd802bf0f4",
                                        "name": "SET_CURRENT_MIN",
                                        "unit": "",
                                        "local_name": "Уставка минимального тока",
                                        "value": 0
                                    },
                                    {
                                        "id": "8da5ce71-ce36-4778-b753-2e8615eb2360",
                                        "name": "SET_MODE",
                                        "unit": "NONE",
                                        "local_name": "Режим работы",
                                        "value": 0
                                    }
                                ],
                                "sequence_number": 1,
                                "metric_set": {
                                    raw: [
                                        {
                                            "id": "ded75593-f3fb-4b57-979c-5358bf5aa525",
                                            "local_name": "Состояние",
                                            "name": "STATE",
                                            "unit": "NONE"
                                        }
                                    ],
                                    "analytical": []
                                }
                            }
                        ]
                    },
                    "nitrate_recycling_pump_group": {
                        "id": "626aae87-b784-4bfb-b743-d0f423c395d9",
                        "name": "Группа насосов нитратного рецикла",
                        "pumps": [
                            {
                                "id": "bd08237c-ab03-479c-ab8a-8300cab5b712",
                                "name": "Насос",
                                "details": [
                                    {
                                        "id": "a7d1b5a2-52e1-48ae-bb36-6f28f2ca6918",
                                        "name": "SET_MODE",
                                        "unit": "NONE",
                                        "local_name": "Режим работы",
                                        "value": 0
                                    },
                                    {
                                        "id": "2cb29014-d26c-47a9-835b-eddde8cc604c",
                                        "name": "SET_CURRENT_MAX",
                                        "unit": "",
                                        "local_name": "Уставка максимального тока",
                                        "value": 0
                                    },
                                    {
                                        "id": "c25a255e-cff0-4db5-9a50-811be59374e2",
                                        "name": "SET_CURRENT_MIN",
                                        "unit": "",
                                        "local_name": "Уставка минимального тока",
                                        "value": 0
                                    }
                                ],
                                "sequence_number": 1,
                                "metric_set": {
                                    "raw": [
                                        {
                                            "id": "631fee3d-fdca-426a-9884-9f2a3f94b77c",
                                            "local_name": "Состояние",
                                            "name": "STATE",
                                            "unit": "NONE"
                                        }
                                    ],
                                    "analytical": []
                                }
                            }
                        ],
                        "details": [],
                        "metric_set": {
                            "raw": [],
                            "analytical": []
                        }
                    }
                },
                "blower_module": {
                    "id": "ac0cb6b0-b273-43eb-8881-b571a28c3c80",
                    "name": "Воздуходувный модуль",
                    "blowers": [
                        {
                            "id": "d2d6ae1f-d72d-4591-a865-02c05f13733f",
                            "name": "Воздуходувка",
                            "details": [
                                {
                                    "id": "4bc6e7e8-260b-46f5-a033-de8e7adf1844",
                                    "name": "SET_CURRENT_MAX",
                                    "unit": "",
                                    "local_name": "Уставка максимального тока",
                                    "value": 0
                                },
                                {
                                    "id": "053822ee-1c84-46b0-a179-f009ce49247b",
                                    "name": "SET_CURRENT_MIN",
                                    "unit": "",
                                    "local_name": "Уставка минимального тока",
                                    "value": 0
                                },
                                {
                                    "id": "666b3a8f-8d00-4215-ad7a-659404813e6e",
                                    "name": "SET_CURRENT_DELTA",
                                    "unit": "",
                                    "local_name": "Уставка максимальной разницы фазных токов",
                                    "value": 0
                                },
                                {
                                    "id": "94fa5510-9d32-46c6-94e3-7f04202aa84a",
                                    "name": "SET_OVERPRESSURE_MAX",
                                    "unit": "",
                                    "local_name": "Уставка максимального избыточного давления",
                                    "value": 0
                                },
                                {
                                    "id": "4bd68f59-fb84-4825-9bac-d17667f5e08c",
                                    "name": "SET_UNDERPRESSURE_MAX",
                                    "unit": "",
                                    "local_name": "Уставка максимального вакуумметрического давления",
                                    "value": 0
                                },
                                {
                                    "id": "8ea368c7-e3af-47a1-ac6b-25428f6b0c86",
                                    "name": "SET_MODE",
                                    "unit": "NONE",
                                    "local_name": "Режим работы",
                                    "value": 0
                                },
                                {
                                    "id": "f037762b-be80-4f35-9df4-cfd0db4ab62f",
                                    "name": "SET_OVERPRESSURE_MIN",
                                    "unit": "",
                                    "local_name": "Уставка минимального избыточного",
                                    "value": 0
                                }
                            ],
                            "sequence_number": 1,
                            "metric_set": {
                                "raw": [
                                    {
                                        "id": "8e454a30-5611-4504-b77b-bb4e46ff39b3",
                                        "local_name": "Потребляемый ток фазы A",
                                        "name": "CURRENT_CONSUMPTION_A",
                                        "unit": ""
                                    },
                                    {
                                        "id": "5c0ce4cf-124a-43aa-beab-29087392b77b",
                                        "local_name": "Потребляемый ток фазы C",
                                        "name": "CURRENT_CONSUMPTION_C",
                                        "unit": ""
                                    },
                                    {
                                        "id": "dc1d3a95-6511-42ea-bcd8-12cfca834b78",
                                        "local_name": "Потребляемый ток фазы B",
                                        "name": "CURRENT_CONSUMPTION_B",
                                        "unit": ""
                                    },
                                    {
                                        "id": "41741db6-0c10-4217-b9dc-37863f3dcce8",
                                        "local_name": "Избыточное давление на выходе",
                                        "name": "OVERPRESSURE",
                                        "unit": ""
                                    },
                                    {
                                        "id": "5ac5cc1c-30e6-4135-b6c2-b9796babd122",
                                        "local_name": "Вакуумметрическое давление на входе",
                                        "name": "UNDERPRESSURE",
                                        "unit": ""
                                    },
                                    {
                                        "id": "19798306-a9ab-4794-b1a0-854495e4d76b",
                                        "local_name": "Состояние",
                                        "name": "STATE",
                                        "unit": "NONE"
                                    }
                                ],
                                "analytical": []
                            }
                        }
                    ],
                    "valves": [
                        {
                            "id": "e4bd453a-9f4b-496e-a422-6dd2224d7bbb",
                            "name": "Электромагнитный клапан",
                            "details": [],
                            "sequence_number": 1,
                            "metric_set": {
                                "raw": [
                                    {
                                        "id": "80fb7b10-8108-40f6-8cfe-174896b21870",
                                        "local_name": "Состояние",
                                        "name": "STATE",
                                        "unit": "NONE"
                                    }
                                ],
                                "analytical": []
                            }
                        },
                        {
                            "id": "028ef264-1d25-4cc6-a878-7fd7a37f1a43",
                            "name": "Электромагнитный клапан",
                            "details": [],
                            "sequence_number": 1,
                            "metric_set": {
                                "raw": [
                                    {
                                        "id": "53c7e9c1-dc6b-483f-82d7-68eb8834e32f",
                                        "local_name": "Состояние",
                                        "name": "STATE",
                                        "unit": "NONE"
                                    }
                                ],
                                "analytical": []
                            }
                        }
                    ],
                    "details": [],
                    "metric_set": {
                        "raw": [
                            {
                                "id": "8889e896-1200-4b14-bd2a-3bac2d3a6f47",
                                "local_name": "Температура в модуле",
                                "name": "TEMPERATURE_INDOOR",
                                "unit": ""
                            },
                            {
                                "id": "7272098c-85a3-403d-aece-964e4866ae5b",
                                "local_name": "Давление в коллекторе",
                                "name": "OVERPRESSURE",
                                "unit": ""
                            }
                        ],
                        "analytical": []
                    }
                },
                "mixers": [
                    {
                        "id": "8d45b442-86ba-4153-b92a-2b92709c65e4",
                        "name": "Мешалка",
                        "details": [],
                        "sequence_number": 1,
                        "metric_set": {
                            "raw": [],
                            "analytical": []
                        }
                    }
                ],
                "sludge_removal_pump": {
                    "id": "8216bb34-917e-4deb-ad00-ee0dcf368426",
                    "name": "Насос осадка",
                    "details": [
                        {
                            "id": "b43e0399-c3ef-4ac5-8fc4-fb330227ba8b",
                            "name": "SET_MODE",
                            "unit": "NONE",
                            "local_name": "Режим работы",
                            "value": 0
                        },
                        {
                            "id": "8583939e-9d0c-4ebf-a9f5-9f8e97afef96",
                            "name": "SET_CURRENT_MAX",
                            "unit": "",
                            "local_name": "Уставка максимального тока",
                            "value": 0
                        }
                    ],
                    "sequence_number": 1,
                    "metric_set": {
                        "raw": [
                            {
                                "id": "d017ceb8-4dac-4b64-bc39-35b02caf1c4d",
                                "local_name": "Состояние",
                                "name": "STATE",
                                "unit": "NONE"
                            }
                        ],
                        "analytical": []
                    }
                },
                "reagents_unit": {
                    "id": "987136cc-38b3-4a1e-b40c-374fa5a68fba",
                    "name": "Узел дозирования реагентов",
                    "dispensers": [
                        {
                            "id": "6e4f8968-b740-47dd-ab94-e11dec30086c",
                            "name": "Дозатор",
                            "details": [
                                {
                                    "id": "49f2fa62-f182-47b3-ad15-38a57770f435",
                                    "name": "SET_MODE",
                                    "unit": "NONE",
                                    "local_name": "Режим работы",
                                    "value": 0
                                }
                            ],
                            "sequence_number": 1,
                            "metric_set": {
                                "raw": [
                                    {
                                        "id": "3c257328-c292-4f5d-9b56-df7cafa79f60",
                                        "local_name": "Состояние",
                                        "name": "STATE",
                                        "unit": "NONE"
                                    }
                                ],
                                "analytical": []
                            }
                        }
                    ],
                    "sequence_number": 1,
                    "metric_set": {
                        "raw": [
                            {
                                "id": "8c11c031-fb2a-4dec-90d9-2352ce41a2ab",
                                "local_name": "Низкий уровень реагента (дискретный)",
                                "name": "LOW_LEVEL",
                                "unit": ""
                            }
                        ],
                        "analytical": []
                    }
                },
                "heating_unit": null,
                "sequence_number": 2,
                "metric_set": {
                    "raw": [
                        {
                            "id": "2431e9ab-f977-4c6f-9d31-d8b0b4f186e3",
                            "local_name": "Температура в денитрификаторе",
                            "name": "TEMPERATURE_DENITRIFIER",
                            "unit": ""
                        },
                        {
                            "id": "c3df4c3d-cbf5-441e-98ea-423cdb5b1831",
                            "local_name": "Температура в биореакторе",
                            "name": "TEMPERATURE_BIOREACTOR",
                            "unit": ""
                        }
                    ],
                    "analytical": []
                }
            },
            {
                "id": "dc1cbf32-e6d4-4643-b66f-0cee108f25c8",
                "name": "Линия биологической очистки",
                "recirculation_group": {
                    "id": "f2740a2e-2ed6-4b1a-b18b-fa4dd5291fe6",
                    "name": "Группа насосов рециркуляции",
                    "return_recycling_pump_group": {
                        "id": "1880a8d3-ad62-402d-b3c4-a14098fcb2be",
                        "name": "Группа насосов возвратного рецикла",
                        "pumps": [
                            {
                                "id": "683e0633-2e77-4f04-b8d9-f4abb15dfdb3",
                                "name": "Насос",
                                "details": [
                                    {
                                        "id": "f86c0a36-3c89-4128-8427-39fa8c08a571",
                                        "name": "SET_CURRENT_MAX",
                                        "unit": "",
                                        "local_name": "Уставка максимального тока",
                                        "value": 0
                                    },
                                    {
                                        "id": "16e15e8a-f143-4451-b7bc-20ecda161eff",
                                        "name": "SET_MODE",
                                        "unit": "NONE",
                                        "local_name": "Режим работы",
                                        "value": 0
                                    },
                                    {
                                        "id": "89dd1409-9060-48d9-b539-c25d5c2b2ff5",
                                        "name": "SET_CURRENT_MIN",
                                        "unit": "",
                                        "local_name": "Уставка минимального тока",
                                        "value": 0
                                    }
                                ],
                                "sequence_number": 1,
                                "metric_set": {
                                    "raw": [
                                        {
                                            "id": "5bb322bc-5f9c-4530-8863-1a46cd449dbe",
                                            "local_name": "Состояние",
                                            "name": "STATE",
                                            "unit": "NONE"
                                        }
                                    ],
                                    "analytical": []
                                }
                            }
                        ],
                        "details": []
                    },
                    "stabilization_pump_group": {
                        "id": "cdff2875-a71c-4ffe-987c-c4dce07b1dbd",
                        "name": "Группа насосов камеры стабилизации",
                        "pumps": [
                            {
                                "id": "5814be21-1273-4c30-a233-e74cd9d12ed6",
                                "name": "Насос",
                                "details": [
                                    {
                                        "id": "4f9ac0f8-c4ed-4abd-af21-94b038a4287e",
                                        "name": "SET_MODE",
                                        "unit": "NONE",
                                        "local_name": "Режим работы",
                                        "value": 0
                                    },
                                    {
                                        "id": "5ea3f1e5-cf4a-4cf3-bcf5-fae748cf8f94",
                                        "name": "SET_CURRENT_MIN",
                                        "unit": "",
                                        "local_name": "Уставка минимального тока",
                                        "value": 0
                                    },
                                    {
                                        "id": "22f6b406-ffda-4af9-a5e5-b2a83cf7bf63",
                                        "name": "SET_CURRENT_MAX",
                                        "unit": "",
                                        "local_name": "Уставка максимального тока",
                                        "value": 0
                                    }
                                ],
                                "sequence_number": 1,
                                "metric_set": {
                                    "raw": [
                                        {
                                            "id": "a5683fd2-1779-40c4-b57e-9d234ed00d68",
                                            "local_name": "Состояние",
                                            "name": "STATE",
                                            "unit": "NONE"
                                        }
                                    ],
                                    "analytical": []
                                }
                            },
                            {
                                "id": "c4e84cec-09a4-42f8-b783-7744af3d38d3",
                                "name": "Насос",
                                "details": [
                                    {
                                        "id": "63572d9b-9079-40b6-ae74-aa1af2861275",
                                        "name": "SET_CURRENT_MAX",
                                        "unit": "",
                                        "local_name": "Уставка максимального тока",
                                        "value": 0
                                    },
                                    {
                                        "id": "0dfdd066-f263-40eb-a9c0-dfae75e16427",
                                        "name": "SET_MODE",
                                        "unit": "NONE",
                                        "local_name": "Режим работы",
                                        "value": 0
                                    },
                                    {
                                        "id": "dccc0192-ee78-4c89-864c-1daf0eba44b7",
                                        "name": "SET_CURRENT_MIN",
                                        "unit": "",
                                        "local_name": "Уставка минимального тока",
                                        "value": 0
                                    }
                                ],
                                "sequence_number": 1,
                                "metric_set": {
                                    "raw": [
                                        {
                                            "id": "26117cf9-b1c1-43fb-9275-6e9f35faf88a",
                                            "local_name": "Состояние",
                                            "name": "STATE",
                                            "unit": "NONE"
                                        }
                                    ],
                                    "analytical": []
                                }
                            }
                        ]
                    },
                    "nitrate_recycling_pump_group": {
                        "id": "80210081-74a9-4168-80ed-7e25336b41ad",
                        "name": "Группа насосов нитратного рецикла",
                        "pumps": [
                            {
                                "id": "e5036e97-ad00-4581-a63f-45ffd6a65d82",
                                "name": "Насос",
                                "details": [
                                    {
                                        "id": "4315dd4d-9070-4034-82bc-63a474743d91",
                                        "name": "SET_CURRENT_MAX",
                                        "unit": "",
                                        "local_name": "Уставка максимального тока",
                                        "value": 0
                                    },
                                    {
                                        "id": "ba8373fa-fb09-484c-907b-67f43960ca2a",
                                        "name": "SET_CURRENT_MIN",
                                        "unit": "",
                                        "local_name": "Уставка минимального тока",
                                        "value": 0
                                    },
                                    {
                                        "id": "22a7b0c5-5485-4aee-ab34-add2a7ce1c9e",
                                        "name": "SET_MODE",
                                        "unit": "NONE",
                                        "local_name": "Режим работы",
                                        "value": 0
                                    }
                                ],
                                "sequence_number": 1,
                                "metric_set": {
                                    "raw": [
                                        {
                                            "id": "012a5b50-f7af-4b60-9c0d-753fa0919441",
                                            "local_name": "Состояние",
                                            "name": "STATE",
                                            "unit": "NONE"
                                        }
                                    ],
                                    "analytical": []
                                }
                            }
                        ],
                        "details": [],
                        "metric_set": {
                            "raw": [],
                            "analytical": []
                        }
                    }
                },
                "blower_module": {
                    "id": "77aa68a8-fb6c-4e40-9622-c78e2165c7a7",
                    "name": "Воздуходувный модуль",
                    "blowers": [
                        {
                            "id": "3276de22-3a8b-4fbd-8aed-b5eaf6d5e2e4",
                            "name": "Воздуходувка",
                            "details": [
                                {
                                    "id": "bf95f05f-e4e3-4db9-90b7-6ce53d326226",
                                    "name": "SET_MODE",
                                    "unit": "NONE",
                                    "local_name": "Режим работы",
                                    "value": 0
                                },
                                {
                                    "id": "edb478e9-4f99-473d-a9d3-b9951df14685",
                                    "name": "SET_CURRENT_DELTA",
                                    "unit": "",
                                    "local_name": "Уставка максимальной разницы фазных токов",
                                    "value": 0
                                },
                                {
                                    "id": "e9e37610-401c-48e2-938a-3ab1263feaf9",
                                    "name": "SET_OVERPRESSURE_MIN",
                                    "unit": "",
                                    "local_name": "Уставка минимального избыточного",
                                    "value": 0
                                },
                                {
                                    "id": "4f913cea-4da1-4a57-b6e5-5987fdcac56d",
                                    "name": "SET_UNDERPRESSURE_MAX",
                                    "unit": "",
                                    "local_name": "Уставка максимального вакуумметрического давления",
                                    "value": 0
                                },
                                {
                                    "id": "5bc5129a-1042-4866-ade4-5448399cd89e",
                                    "name": "SET_CURRENT_MAX",
                                    "unit": "",
                                    "local_name": "Уставка максимального тока",
                                    "value": 0
                                },
                                {
                                    "id": "2a816c4c-6e9e-4c99-a958-8884297a93b5",
                                    "name": "SET_CURRENT_MIN",
                                    "unit": "",
                                    "local_name": "Уставка минимального тока",
                                    "value": 0
                                },
                                {
                                    "id": "410d55ca-180a-4381-9e29-909526d5e331",
                                    "name": "SET_OVERPRESSURE_MAX",
                                    "unit": "",
                                    "local_name": "Уставка максимального избыточного давления",
                                    "value": 0
                                }
                            ],
                            "sequence_number": 1,
                            "metric_set": {
                                "raw": [
                                    {
                                        "id": "140a5788-c2f3-4251-bcf7-44ef8895b8c7",
                                        "local_name": "Избыточное давление на выходе",
                                        "name": "OVERPRESSURE",
                                        "unit": ""
                                    },
                                    {
                                        "id": "d930b4fc-c29c-4ff3-a518-6f6bdb2d093b",
                                        "local_name": "Вакуумметрическое давление на входе",
                                        "name": "UNDERPRESSURE",
                                        "unit": ""
                                    },
                                    {
                                        "id": "29931ceb-0690-4f31-9d34-121a2de731b7",
                                        "local_name": "Потребляемый ток фазы A",
                                        "name": "CURRENT_CONSUMPTION_A",
                                        "unit": ""
                                    },
                                    {
                                        "id": "4cf30037-186f-446b-bf25-f1cb929747d4",
                                        "local_name": "Потребляемый ток фазы B",
                                        "name": "CURRENT_CONSUMPTION_B",
                                        "unit": ""
                                    },
                                    {
                                        "id": "21d353ba-1af9-4ef1-a7d1-23d8f3bc61ba",
                                        "local_name": "Состояние",
                                        "name": "STATE",
                                        "unit": "NONE"
                                    },
                                    {
                                        "id": "f9b50f8a-c6ca-4b69-ba3f-652ca6071fa4",
                                        "local_name": "Потребляемый ток фазы C",
                                        "name": "CURRENT_CONSUMPTION_C",
                                        "unit": ""
                                    }
                                ],
                                "analytical": []
                            }
                        }
                    ],
                    "valves": [
                        {
                            "id": "15620de7-01bc-44fd-8a5e-88a647620c76",
                            "name": "Электромагнитный клапан",
                            "details": [],
                            "sequence_number": 1,
                            "metric_set": {
                                "raw": [
                                    {
                                        "id": "f67c128b-d12a-4390-ad69-75bfc2624cff",
                                        "local_name": "Состояние",
                                        "name": "STATE",
                                        "unit": "NONE"
                                    }
                                ],
                                "analytical": []
                            }
                        },
                        {
                            "id": "44898c3e-d1f9-4c97-b168-e0cd960206bd",
                            "name": "Электромагнитный клапан",
                            "details": [],
                            "sequence_number": 1,
                            "metric_set": {
                                "raw": [
                                    {
                                        "id": "b2a9ac5a-ce98-4ed4-b631-a5f037763c69",
                                        "local_name": "Состояние",
                                        "name": "STATE",
                                        "unit": "NONE"
                                    }
                                ],
                                "analytical": []
                            }
                        }
                    ],
                    "details": [],
                    "metric_set": {
                        "raw": [
                            {
                                "id": "21260834-724b-44b9-b893-6941d093c462",
                                "local_name": "Температура в модуле",
                                "name": "TEMPERATURE_INDOOR",
                                "unit": ""
                            },
                            {
                                "id": "1fbd83c8-54bb-42ee-8d13-e12368b9253e",
                                "local_name": "Давление в коллекторе",
                                "name": "OVERPRESSURE",
                                "unit": ""
                            }
                        ],
                        "analytical": []
                    }
                },
                "mixers": [
                    {
                        "id": "ab305f92-cba4-4b19-bf4d-91a08e52f3dc",
                        "name": "Мешалка",
                        "details": [],
                        "sequence_number": 1,
                        "metric_set": {
                            "raw": [],
                            "analytical": []
                        }
                    }
                ],
                "sludge_removal_pump": {
                    "id": "7d0b9d7d-b2f1-4b3e-9ee8-9d6c0dfa5698",
                    "name": "Насос осадка",
                    "details": [
                        {
                            "id": "110a9040-d956-4824-93cf-b2ae43431476",
                            "name": "SET_CURRENT_MAX",
                            "unit": "",
                            "local_name": "Уставка максимального тока",
                            "value": 0
                        },
                        {
                            "id": "b848529b-3b61-4a2e-a9ae-8afb243d43ce",
                            "name": "SET_MODE",
                            "unit": "NONE",
                            "local_name": "Режим работы",
                            "value": 0
                        }
                    ],
                    "sequence_number": 1,
                    "metric_set": {
                        "raw": [
                            {
                                "id": "7c7318cd-fd79-4ad8-99b6-6f1fdec6b36a",
                                "local_name": "Состояние",
                                "name": "STATE",
                                "unit": "NONE"
                            }
                        ],
                        "analytical": []
                    }
                },
                "reagents_unit": {
                    "id": "4726f5f2-91bd-44e8-aaac-5ed11e0d4567",
                    "name": "Узел дозирования реагентов",
                    "dispensers": [
                        {
                            "id": "955b7ae6-ced7-4aee-86d2-a55c71e1824d",
                            "name": "Дозатор",
                            "details": [
                                {
                                    "id": "6b3eba20-4f17-49f5-9340-d1438c1a1a1f",
                                    "name": "SET_MODE",
                                    "unit": "NONE",
                                    "local_name": "Режим работы",
                                    "value": 0
                                }
                            ],
                            "sequence_number": 1,
                            "metric_set": {
                                "raw": [
                                    {
                                        "id": "ef18eb91-2bbd-42b9-ba7d-3059424b623a",
                                        "local_name": "Состояние",
                                        "name": "STATE",
                                        "unit": "NONE"
                                    }
                                ],
                                "analytical": []
                            }
                        }
                    ],
                    "sequence_number": 1,
                    "metric_set": {
                        "raw": [
                            {
                                "id": "cf7353d2-796a-4f6e-9c24-916e350c42fb",
                                "local_name": "Низкий уровень реагента (дискретный)",
                                "name": "LOW_LEVEL",
                                "unit": ""
                            }
                        ],
                        "analytical": []
                    }
                },
                "heating_unit": null,
                "sequence_number": 1,
                "metric_set": {
                    "raw": [
                        {
                            "id": "55fd2847-1129-4776-bab7-03cbbc2d545b",
                            "local_name": "Температура в денитрификаторе",
                            "name": "TEMPERATURE_DENITRIFIER",
                            "unit": ""
                        },
                        {
                            "id": "f65f56a7-5120-4497-8d2e-38f0c280ecc9",
                            "local_name": "Температура в биореакторе",
                            "name": "TEMPERATURE_BIOREACTOR",
                            "unit": ""
                        }
                    ],
                    "analytical": []
                }
            }
        ],
        "alta_bio_cleans": [
            {
                "id": "80f0e394-ac9e-48af-a222-ab9e11f55564",
                "name": "Узел доочистки и обеззараживания",
                "pumps": [
                    {
                        "id": "34ce790f-d840-4803-8b35-0c7a4d93c6f3",
                        "name": "Насос",
                        "details": [
                            {
                                "id": "8d0842e6-de30-41cb-9443-dab0f182bed6",
                                "name": "SET_MODE",
                                "unit": "NONE",
                                "local_name": "Режим работы",
                                "value": 0
                            },
                            {
                                "id": "f355eb40-416b-4960-828b-8376363633a9",
                                "name": "SET_CURRENT_MAX",
                                "unit": "",
                                "local_name": "Уставка максимального тока",
                                "value": 0
                            },
                            {
                                "id": "3946b19d-b3ad-40b0-a7b9-28aee1ea6801",
                                "name": "SET_CURRENT_MIN",
                                "unit": "",
                                "local_name": "Уставка минимального тока",
                                "value": 0
                            }
                        ],
                        "sequence_number": 1,
                        "metric_set": {
                            "raw": [
                                {
                                    "id": "6f0c3685-7f4e-482d-9719-537fef657bc4",
                                    "local_name": "Состояние",
                                    "name": "STATE",
                                    "unit": "NONE"
                                }
                            ],
                            "analytical": []
                        }
                    },
                    {
                        "id": "f453aec0-3919-46ad-acbf-e6f73b3222fd",
                        "name": "Насос",
                        "details": [
                            {
                                "id": "58ef5b40-aeea-474b-9851-972639f93f8a",
                                "name": "SET_CURRENT_MIN",
                                "unit": "",
                                "local_name": "Уставка минимального тока",
                                "value": 0
                            },
                            {
                                "id": "aa4f0a79-3da9-450f-b904-9cf5c399c028",
                                "name": "SET_CURRENT_MAX",
                                "unit": "",
                                "local_name": "Уставка максимального тока",
                                "value": 0
                            },
                            {
                                "id": "e0212f16-1654-4af2-99fb-b17dc34883e1",
                                "name": "SET_MODE",
                                "unit": "NONE",
                                "local_name": "Режим работы",
                                "value": 0
                            }
                        ],
                        "sequence_number": 1,
                        "metric_set": {
                            "raw": [
                                {
                                    "id": "f100627a-62d1-4be4-b8c1-7c75685c7122",
                                    "local_name": "Состояние",
                                    "name": "STATE",
                                    "unit": "NONE"
                                }
                            ],
                            "analytical": []
                        }
                    }
                ],
                "filters": [
                    {
                        "id": "28c0de33-173f-4b41-ac3d-3c88d56a6ebd",
                        "name": "Фильтр",
                        "details": [],
                        "sequence_number": 1,
                        "metric_set": {
                            "raw": [],
                            "analytical": []
                        }
                    },
                    {
                        "id": "c8a0e8c5-6b04-45d7-85c3-9455ca379f2d",
                        "name": "Фильтр",
                        "details": [],
                        "sequence_number": 1,
                        "metric_set": {
                            "raw": [],
                            "analytical": []
                        }
                    }
                ],
                "details": [
                    {
                        "id": "4f1b3e82-90d2-4df4-a3e0-76f51f931f5f",
                        "name": "SET_SELECTED_PUMPS",
                        "unit": "",
                        "local_name": "Выбор насосов для ручного режима",
                        "value": 0
                    },
                    {
                        "id": "eb805731-ec57-4743-afb6-e340020cccd3",
                        "name": "SET_MODE",
                        "unit": "NONE",
                        "local_name": "Режим работы",
                        "value": 0
                    }
                ],
                "sequence_number": 1,
                "metric_set": {
                    "raw": [
                        {
                            "id": "f95eb1a3-55b5-4cd4-971a-d7e777d403f4",
                            "local_name": "Мгновенный расход сточных вод",
                            "name": "FLOW_RATE",
                            "unit": ""
                        },
                        {
                            "id": "39334519-5def-40af-96a3-3fccf172122a",
                            "local_name": "Поступление сточных вод",
                            "name": "ACCUMULATED_VOLUME",
                            "unit": ""
                        },
                        {
                            "id": "8e61e7a1-4cd5-488d-8b3a-58909072cbe3",
                            "local_name": "Температура в камере оборудования",
                            "name": "TEMPERATURE_INDOOR",
                            "unit": ""
                        }
                    ],
                    "analytical": []
                }
            }
        ],
        "pumping_units": [
            {
                "id": "72fdb189-54d3-4622-ab23-21c850682db4",
                "name": "Насосная станция",
                "pumps": [
                    {
                        "id": "d70b6cbd-0369-4636-9943-0201c94a7c41",
                        "name": "Насос",
                        "details": [
                            {
                                "id": "df387e1e-db35-4c3f-9208-19599f87c800",
                                "name": "SET_CURRENT_MIN",
                                "unit": "",
                                "local_name": "Уставка минимального тока",
                                "value": 0
                            },
                            {
                                "id": "738672cd-8749-4c48-bfdf-d9238a63ffb7",
                                "name": "SET_CURRENT_MAX",
                                "unit": "",
                                "local_name": "Уставка максимального тока",
                                "value": 0
                            },
                            {
                                "id": "b1223502-d8b7-4c41-8fce-cff1b3522d6a",
                                "name": "SET_MODE",
                                "unit": "NONE",
                                "local_name": "Режим работы",
                                "value": 0
                            }
                        ],
                        "sequence_number": 1,
                        "metric_set": {
                            "raw": [
                                {
                                    "id": "aa298b46-5003-4d2c-9de2-f7ad49d2a885",
                                    "local_name": "Состояние",
                                    "name": "STATE",
                                    "unit": "NONE"
                                }
                            ],
                            "analytical": []
                        }
                    },
                    {
                        "id": "e0069481-298a-4b69-aa8d-22064c223516",
                        "name": "Насос",
                        "details": [
                            {
                                "id": "92f3b4e3-f814-4176-bfbf-3278eab043c9",
                                "name": "SET_CURRENT_MIN",
                                "unit": "",
                                "local_name": "Уставка минимального тока",
                                "value": 0
                            },
                            {
                                "id": "0491e8c7-2ee0-40b9-8d7e-9a4d4b20ea06",
                                "name": "SET_MODE",
                                "unit": "NONE",
                                "local_name": "Режим работы",
                                "value": 0
                            },
                            {
                                "id": "5e4350e1-ebef-4b6a-9723-449b0f82cded",
                                "name": "SET_CURRENT_MAX",
                                "unit": "",
                                "local_name": "Уставка максимального тока",
                                "value": 0
                            }
                        ],
                        "sequence_number": 1,
                        "metric_set": {
                            "raw": [
                                {
                                    "id": "338cf635-888a-4a78-a154-841c7f4534c7",
                                    "local_name": "Состояние",
                                    "name": "STATE",
                                    "unit": "NONE"
                                }
                            ],
                            "analytical": []
                        }
                    }
                ],
                "details": [
                    {
                        "id": "1a64768e-382b-45f7-9236-72353d0b40d1",
                        "name": "SET_SELECTED_PUMPS",
                        "unit": "",
                        "local_name": "Выбор насосов для ручного режима",
                        "value": 0
                    },
                    {
                        "id": "9f6c10e7-7f7b-4b10-bf90-d1bea1e77eb6",
                        "name": "SET_PAUSE_DURATION",
                        "unit": "",
                        "local_name": "Уставка длительности паузы",
                        "value": 0
                    },
                    {
                        "id": "a50d3c4f-619a-47e1-9851-0c36f9869109",
                        "name": "SET_MODE",
                        "unit": "NONE",
                        "local_name": "Режим работы",
                        "value": 0
                    },
                    {
                        "id": "32de33ef-8544-4058-ae36-a27d79a246ee",
                        "name": "SET_RUN_DURATION",
                        "unit": "",
                        "local_name": "Уставка длительности работы",
                        "value": 0
                    }
                ],
                "gate_valves": [],
                "sequence_number": 1,
                "metric_set": {
                    "raw": [
                        {
                            "id": "f6443161-bd4a-4511-bac0-9f31df4fd6cc",
                            "local_name": "Уровень (м. в. ст.)",
                            "name": "LEVEL",
                            "unit": ""
                        },
                        {
                            "id": "f8c888fc-d4d3-459c-89d0-3d07c8fb6774",
                            "local_name": "Верхний уровень (дискретный)",
                            "name": "UPPER_LEVEL",
                            "unit": ""
                        },
                        {
                            "id": "b4d4e80e-e514-40f6-a83d-af34d18075c4",
                            "local_name": "Аварийный уровень (дискретный)",
                            "name": "ALARM_LEVEL",
                            "unit": ""
                        },
                        {
                            "id": "34a471b0-a179-4c6f-b980-a186c9c8ce9a",
                            "local_name": "Нижний уровень (дискретный)",
                            "name": "LOW_LEVEL",
                            "unit": ""
                        }
                    ],
                    "analytical": []
                }
            }
        ],
        "climate_controls": [],
        "mechanical_cleaning_unit": {
            "id": "fa0a47ba-053d-4924-aab0-c814fe2e390e",
            "name": "Мехочистка",
            "cdgs": [],
            "screens": [
                {
                    "id": "f74459ae-8f51-4e09-8592-8ec172c38fa8",
                    "name": "Решетка",
                    "details": [],
                    "sequence_number": 1,
                    "metric_set": {
                        "raw": [],
                        "analytical": []
                    }
                }
            ],
            "compressors": [],
            "gate_valves": [],
            "pumps": [],
            "conveyors": [],
            "reagents_unit": null
        },
        "surge_unit": {
            "id": "02feca9a-a0fb-47b5-b44a-a23ecb01e631",
            "name": "Усреднитель",
            "mixers": [
                {
                    "id": "b938f754-ad32-4656-9779-bb5416c41abc",
                    "name": "Мешалка",
                    "details": [],
                    "sequence_number": 1,
                    "metric_set": {
                        "raw": [],
                        "analytical": []
                    }
                }
            ],
            "pumping_units": [
                {
                    "id": "8cc7083e-8e12-4e2a-8121-66f3988a28c8",
                    "name": "Насосная станция",
                    "pumps": [
                        {
                            "id": "5fdd4481-59ba-4059-9139-075b3fdb7c0f",
                            "name": "Насос",
                            "details": [
                                {
                                    "id": "5980eb15-3461-4ed8-8cea-8824c6f8aae1",
                                    "name": "SET_MODE",
                                    "unit": "NONE",
                                    "local_name": "Режим работы",
                                    "value": 0
                                },
                                {
                                    "id": "3819ccb2-6ec6-4bbc-8ac0-58ab2a82e2b9",
                                    "name": "SET_CURRENT_MAX",
                                    "unit": "",
                                    "local_name": "Уставка максимального тока",
                                    "value": 0
                                },
                                {
                                    "id": "6e8e29b6-926a-4cb6-93d9-d6ce2c9c4436",
                                    "name": "SET_CURRENT_MIN",
                                    "unit": "",
                                    "local_name": "Уставка минимального тока",
                                    "value": 0
                                }
                            ],
                            "sequence_number": 1,
                            "metric_set": {
                                "raw": [
                                    {
                                        "id": "839802a8-3d67-439a-a7fe-5c4cb09435c3",
                                        "local_name": "Состояние",
                                        "name": "STATE",
                                        "unit": "NONE"
                                    }
                                ],
                                "analytical": []
                            }
                        }
                    ],
                    "details": [
                        {
                            "id": "5409d19f-8e4b-40c0-950a-6112037e7b3b",
                            "name": "SET_PAUSE_DURATION",
                            "unit": "",
                            "local_name": "Уставка длительности паузы",
                            "value": 0
                        },
                        {
                            "id": "41b78379-221d-41c1-8179-ffb78dfa9ded",
                            "name": "SET_MODE",
                            "unit": "NONE",
                            "local_name": "Режим работы",
                            "value": 0
                        },
                        {
                            "id": "7b7110e6-1e40-437f-93da-3e0714bac269",
                            "name": "SET_SELECTED_PUMPS",
                            "unit": "",
                            "local_name": "Выбор насосов для ручного режима",
                            "value": 0
                        },
                        {
                            "id": "361463ca-7a2a-4049-a430-657a5e070744",
                            "name": "SET_RUN_DURATION",
                            "unit": "",
                            "local_name": "Уставка длительности работы",
                            "value": 0
                        }
                    ],
                    "gate_valves": [],
                    "sequence_number": 1,
                    "metric_set": {
                        "raw": [
                            {
                                "id": "a916a472-7880-41c2-b0cc-11193ee7260b",
                                "local_name": "Аварийный уровень (дискретный)",
                                "name": "ALARM_LEVEL",
                                "unit": ""
                            },
                            {
                                "id": "caced876-577f-4e66-9e4e-40530188d723",
                                "local_name": "Уровень (м. в. ст.)",
                                "name": "LEVEL",
                                "unit": ""
                            },
                            {
                                "id": "c2199999-a7c5-4633-9d94-35cb195a284d",
                                "local_name": "Верхний уровень (дискретный)",
                                "name": "UPPER_LEVEL",
                                "unit": ""
                            },
                            {
                                "id": "0d779b44-97b8-4c3f-822c-5587dbf27d7c",
                                "local_name": "Нижний уровень (дискретный)",
                                "name": "LOW_LEVEL",
                                "unit": ""
                            }
                        ],
                        "analytical": []
                    }
                }
            ],
            "blower_module": null,
            "metric_set": {
                "raw": [
                    {
                        "id": "bff9a22e-6a38-40e4-9dae-abe20b8f1492",
                        "local_name": "Уровень (м. в. ст.)",
                        "name": "LEVEL",
                        "unit": ""
                    }
                ],
                "analytical": []
            }
        },
        "sludge_treatment_unit": {
            "id": "d53dae2a-a394-4b77-8112-9efd1887f1b1",
            "name": "Узел обработки осадка",
            "reagents_units": [
                {
                    "id": "0b85c65f-0c6c-42e4-939c-c83d41277f74",
                    "name": "Узел дозирования реагентов",
                    "dispensers": [
                        {
                            "id": "64065ee3-e52b-4cc8-a9c6-570eeff56d12",
                            "name": "Дозатор",
                            "details": [
                                {
                                    "id": "42cb1032-05e9-47b9-918a-91833911c24b",
                                    "name": "SET_MODE",
                                    "unit": "NONE",
                                    "local_name": "Режим работы",
                                    "value": 0
                                }
                            ],
                            "sequence_number": 1,
                            "metric_set": {
                                "raw": [
                                    {
                                        "id": "dde5ef56-0dd2-4461-b4dc-ad345d68439c",
                                        "local_name": "Состояние",
                                        "name": "STATE",
                                        "unit": "NONE"
                                    }
                                ],
                                "analytical": []
                            }
                        }
                    ],
                    "sequence_number": 1,
                    "metric_set": {
                        "raw": [],
                        "analytical": []
                    }
                }
            ],
            "dewaterers": [],
            "sludge_tank": null,
            "sludge_storage_accumulator": null,
            "flocculant_station": null,
            "metric_set": {
                "raw": [],
                "analytical": []
            }
        },
        "trace_heating": null,
        "station_info": {
            "address": {
                "address": "Демонстрационная площадка №1",
                "region_code": "7000000000000"
            },
            "documentation": [
                {
                    id: "0",
                    filename: "Очень_длинное_название_файла",
                    extension: "zip",
                    url: "url",
                    size: 1024,
                },
                {
                    id: "1",
                    filename: "PDF-файл",
                    extension: "pdf",
                    url: "url",
                    size: 1024,
                },
                {
                    id: "2",
                    filename: "XLSX-файл представляете вот так вот",
                    extension: "xlsx",
                    url: "url",
                    size: 1024,
                },
                {
                    id: "3",
                    filename: "ну какой же длинный этот DOC-файл это просто жесть невозможно сидеть сложа руки и смотреть",
                    extension: "doc",
                    url: "url",
                    size: 1024,
                },
                {
                    id: "4",
                    filename: "DOCX-файл",
                    extension: "docx",
                    url: "url",
                    size: 1024,
                },
                {
                    id: "5",
                    filename: "RFA-файл",
                    extension: "rfa",
                    url: "url",
                    size: 1024,
                },
                {
                    id: "6",
                    filename: "PNG-файл",
                    extension: "png",
                    url: "url",
                    size: 1024,
                },
                {
                    id: "7",
                    filename: "JPG-файл",
                    extension: "jpg",
                    url: "url",
                    size: 1024,
                },
                {
                    id: "8",
                    filename: "JPEG-файл",
                    extension: "jpeg",
                    url: "https://staging.alta-cloud.ru/api/v2/stations/files/f7d191b2-cf6b-44b3-b47a-c97cf16ca9b1",
                    size: 1024,
                },
            ],
            "customer": {
                "name": "ООО «Демонстрационный Водоканал»",
                "tin": "0000000000"
            }
        },
        "technological_parameters": {
            "daily_volume": {
                "tankered": 0,
                "channeled": 1000
            },
            "average_hourly_volume": 41.7,
            "peak_volume": 73,
            "min_temperature": 8,
            "max_temperature": 22
        },
        "metric_set": {
            "raw": [
                {
                    "id": "1070c7e5-0ffd-48fc-a900-28bf476e9318",
                    "local_name": "Поступление сточных вод на входе",
                    "name": "ACCUMULATED_VOLUME_INLET",
                    "unit": ""
                },
                {
                    "id": "65ac64fe-6a00-404d-b848-91725be83220",
                    "local_name": "Мгновенный расход сточных вод на входе",
                    "name": "FLOW_RATE_INLET",
                    "unit": ""
                }
            ],
            "analytical": []
        }
    },
    "87fe8fb2-4876-41b8-92a0-cf07ae86cddb": {
        "id": "87fe8fb2-4876-41b8-92a0-cf07ae86cddb",
        "pcid": "areibuj7mb26i7rj0c5r",
        "name": "Демонстрационный объект №2",
        "connection_status": ConnectionStatus.CONNECTED,
        "is_authorized": false,
        "required_action": RequiredActionEnum.CHANGE_REQUEST,
        "blower_module": null,
        air_masters_pro: [],
        alta_bio_cleans: [],
        pumping_units: [],
        climate_controls: [],
        mechanical_cleaning_unit: null,
        surge_unit: null,
        sludge_treatment_unit: null,
        trace_heating: null,
        "station_info": {
            "address": {
                "address": null,
                "region_code": null
            },
            "documentation": [],
            "customer": {
                "name": null,
                "tin": null
            }
        },
        "technological_parameters": {
            "daily_volume": {
                "tankered": 0,
                "channeled": 350
            },
            "average_hourly_volume": 14.6,
            "peak_volume": 25,
            "min_temperature": 8,
            "max_temperature": 20
        },
        "metric_set": {
            "raw": [],
            "analytical": []
        }
    },
};
const users: Record<string, UserConsole> = {
    "0": {
        id: "0",
        name: "Вася",
        email: "email1@email.com",
        phone: "+70000000000",
    },
    "1": {
        id: "1",
        name: "Петя",
        email: "email2@email.com",
        phone: "+71111111111",
    },
    "2": {
        id: "2",
        name: "Ваня",
        email: "email3@email.com",
        phone: "+72222222222",
    },
};

const apiUrl = "*/api/v2";
const stationsUrl = apiUrl + "/stations";
const parametersUrl = apiUrl + "/stations/:id/console/technological_parameters";
const authUrl = apiUrl + "/stations/:id/console/authorization";
const configureUrl = apiUrl + "/stations/:id/console/configuration";
const detachUrl = apiUrl + "/stations/:id/console/detach";
const usersUrl = apiUrl + "/stations/:id/console/binding";
const stationInfoUrl = apiUrl + "/stations/:id/console/info";
const fileUploadUrl = apiUrl + "/stations/:id/console/files";
const bindStationUrl = apiUrl + "/stations/binding";

const getAllStations = http.get(stationsUrl, async () => {
    await waitTime(1000);
    // return HttpResponse.json([])

    return HttpResponse.json(Object.values(stations).map(st => ({
        id: st.id,
        pcid: st.pcid,
        name: st.name,
        connection_status: st.connection_status,
        address: st.station_info.address
    })));
});

const postStationBinding = http.post(bindStationUrl, async () => {
    await waitTime(1000);
    const errorMessage: MessageStatus = {
        message: "ok",
        status: "station not found"
    };
    const successMessage: MessageStatus = {
        message: "ok",
        status: "ok"
    };
    // return HttpResponse.json(errorMessage)
    return HttpResponse.json(successMessage);
    // return HttpResponse.error()
});

const getOneStation = http.get(`${stationsUrl}/:id`, async ({params}) => {
    const id = params["id"] as string;

    await waitTime(1000);
    return HttpResponse.json(stations[id]);
});

const patchStation = http.patch(`${stationsUrl}/:id`, async ({params, request}) => {
    const id = params["id"] as string;
    const data: any = await request.json();

    stations[id] = {
        ...stations[id],
        ...data,
    };

    await waitTime(1000);
    return HttpResponse.json(stations[id]);
});

const getStationConsoleList = http.get(`${stationsUrl}/console`, async () => {
    const entities = Object.values(stations).map(st => ({
        id: st.id,
        pcid: st.pcid,
        name: st.name,
        customer: st.station_info.customer.name,
        address: st.station_info.address,
        connection_status: st.connection_status,
        required_action: st.required_action,
    }));

    await waitTime(1000);
    return HttpResponse.json({
        page_number: 1, page_size: 6, total_pages: 1, total_elements: 6, last: true, empty: false, content: entities,
    });
});

const getStationConsoleInfo = http.get(`${stationsUrl}/:id/console`, async ({params}) => {
    const id = params["id"] as string;
    const station = stations[id];

    await waitTime(1000);
    return HttpResponse.json({station, connected_users: Object.values(users)});
});

const putStationParameters = http.put(parametersUrl, async () => {
    await waitTime(1000);
    return HttpResponse.json(null);
});

const patchStationAuthorizationAction = http.patch(authUrl, async () => {
    await waitTime(1000);
    return HttpResponse.json(null);
});

const patchStationEditAction = http.patch(configureUrl, async () => {
    await waitTime(1000);
    return HttpResponse.json(null);
});

const postDetachStation = http.post(detachUrl, async ({params}) => {
    const id = params["id"] as string;
    await waitTime(1000);
    return HttpResponse.json({
        "message": `request to detach station ${id} was received`
    });
});

const patchStationUsers = http.patch(usersUrl, async ({request, params}) => {
    const id = params["id"] as string;
    const body = await request.json() as Record<string, any>;
    const url = new URL(request.url);
    const action = url.searchParams.get("action");

    for (let userId in body) {
        if (action === "bind") {
            users[userId] = body[userId];
        } else {
            delete users[userId];
        }
    }

    await waitTime(1000);
    return HttpResponse.json({
        station_id: id,
        users: Object.values(users),
    });
});

const putStationInfo = http.put(stationInfoUrl, async ({request, params}) => {
    const body = await request.json() as any;
    const id = params["id"] as string;

    const documentation = stations[id].station_info.documentation;
    const newDocumentation = documentation.filter(file => body.documentation.find((entity: any) => entity.id === file.id));
    stations[id].station_info = {
        ...body,
        documentation: newDocumentation,
    };
    await waitTime(1000);
    return HttpResponse.json({
        ...stations[id].station_info
    });
});

const postFile = http.post(fileUploadUrl, async ({request}) => {
    const body = await request.formData();
    const file = body.get("file");

    await waitTime(1000);
    console.log("file uploaded", file);

    return HttpResponse.json([]);
});

export const stationHandlers = [
    postDetachStation,
    patchStationEditAction,
    patchStationAuthorizationAction,
    putStationParameters,
    putStationInfo,
    postFile,
    patchStationUsers,
    getStationConsoleInfo,
    getStationConsoleList,
    getAllStations,
    getOneStation,
    patchStation,
    postStationBinding
];
